<nz-layout class="container-layout">

  <div class="nav-section "> <!-- tw-hidden md:tw-flex -->
    <app-dropdown-menu [innerWidth]="this.innerWidth" [hasPanelTemplate]="hasTemplate" >
    </app-dropdown-menu>
  </div>
  <div *ngIf="hasTemplate" [ngStyle]="{opacity: !isCollapsed ? '0' : 1, 'transition-delay': !isCollapsed ? '0s' : '0.3s' , 'z-index': isCollapsed ? 98 : 0}" (click)="onClosable(false)" class="icon-toggle-menu tw-ml-[58px] tw-mt-[8px] md:tw-mt-[30px] md:tw-ml-[87px]">
    <span class="tw-inline-block tw-mr-2 md:tw-hidden">Panel</span>
    <i nz-icon nzType="menu-unfold" nzTheme="outline" class="trigger"></i>
  </div>
  <nz-sider nzCollapsible [nzWidth]="innerWidth <= 450 ? innerWidth + 'px' : '450px'" [nzCollapsedWidth]="0" [(nzCollapsed)]="isCollapsed" [nzTrigger]="null" [class.float]="changeFloat" *ngIf="hasTemplate"
  class="tw-top-[55px] md:tw-top-0"

  >
    <ng-scrollbar class="my-scrollbar scrollbar-utilities">
      <div class="utilities" [ngStyle]="{'min-width': innerWidth <= 450 ? innerWidth + 'px' : '450px'}">
        <div class="d-flex justify-content-between align-items-center" *ngIf="templateTitle">
          <h2 class="text-title-lg">{{ templateTitle ? templateTitle : '' }}</h2>
          <div *ngIf="!isCollapsed" (click)="onClosable(true)" class="icon-hide-menu cursor-pointer" [class.tw-pointer-events-none]="blockCloseCollapseMenu">
            <i nz-icon nzType="menu-fold" nzTheme="outline" class="trigger"></i>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="tplFormUtilitiesPanel"></ng-container>
      </div>
    </ng-scrollbar>
  </nz-sider>
  <nz-layout style="background-color: #f6f6fb;" class="pl-0 md:tw-pl-[65px] tw-pt-[60px] md:tw-pt-0 ">

   <!--  <app-mobile-menu class="tw-block md:tw-hidden " [hasPanelTemplate]="hasTemplate" ></app-mobile-menu> -->
    <ng-scrollbar class="my-scrollbar scrollbar-content">
      <nz-content class="tw-p-[15px] md:tw-p-[30px] tw-overflow-clip" [ngStyle]="{'margin-left': !hasTemplate ? '0' : isCollapsed && innerWidth > 767 ? '57px' : '0'}">
        <router-outlet></router-outlet>
      </nz-content>
    </ng-scrollbar>
  </nz-layout>
</nz-layout>
